import { useContext, useEffect } from 'react';

import { ControlsContext } from 'features/App/Contexts';

// The sticky list column sits below the sticky app controls, whose height depends on the filters
// flag and on chip wrapping, so the stylesheet reads it from this property instead of a constant.
// The ControlsContext provider lives inside ColumnLayout, so this has to render within a Column.
export const CONTROLS_HEIGHT_PROPERTY = '--schedule-controls-height';

const ScheduleControlsHeightSync = () => {
  const controlsRef = useContext(ControlsContext);

  useEffect(() => {
    const controls = controlsRef?.current;
    if (!controls || typeof ResizeObserver === 'undefined') return undefined;

    const syncControlsHeight = () => {
      document.documentElement.style.setProperty(CONTROLS_HEIGHT_PROPERTY, `${controls.offsetHeight}px`);
    };
    const observer = new ResizeObserver(syncControlsHeight);
    observer.observe(controls);
    syncControlsHeight();

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(CONTROLS_HEIGHT_PROPERTY);
    };
  }, [controlsRef]);

  return null;
};

export default ScheduleControlsHeightSync;
